'use strict'; // --------------------------------------------------------------------
// Imports
// --------------------------------------------------------------------

var common = require('./common');

var nodes = require('./nodes');

var pexprs = require('./pexprs'); // --------------------------------------------------------------------
// Operations
// --------------------------------------------------------------------


pexprs.PExpr.prototype.check = common.abstract('check');

pexprs.any.check = function (grammar, vals) {
  return vals.length >= 1;
};

pexprs.end.check = function (grammar, vals) {
  return vals[0] instanceof nodes.Node && vals[0].isTerminal() && vals[0].primitiveValue === undefined;
};

pexprs.Terminal.prototype.check = function (grammar, vals) {
  return vals[0] instanceof nodes.Node && vals[0].isTerminal() && vals[0].primitiveValue === this.obj;
};

pexprs.Range.prototype.check = function (grammar, vals) {
  return vals[0] instanceof nodes.Node && vals[0].isTerminal() && typeof vals[0].primitiveValue === typeof this.from;
};

pexprs.Param.prototype.check = function (grammar, vals) {
  return vals.length >= 1;
};

pexprs.Alt.prototype.check = function (grammar, vals) {
  for (var i = 0; i < this.terms.length; i++) {
    var term = this.terms[i];

    if (term.check(grammar, vals)) {
      return true;
    }
  }

  return false;
};

pexprs.Seq.prototype.check = function (grammar, vals) {
  var pos = 0;

  for (var i = 0; i < this.factors.length; i++) {
    var factor = this.factors[i];

    if (factor.check(grammar, vals.slice(pos))) {
      pos += factor.getArity();
    } else {
      return false;
    }
  }

  return true;
};

pexprs.Iter.prototype.check = function (grammar, vals) {
  var arity = this.getArity();
  var columns = vals.slice(0, arity);

  if (columns.length !== arity) {
    return false;
  }

  var rowCount = columns[0].length;
  var i;

  for (i = 1; i < arity; i++) {
    if (columns[i].length !== rowCount) {
      return false;
    }
  }

  for (i = 0; i < rowCount; i++) {
    var row = [];

    for (var j = 0; j < arity; j++) {
      row.push(columns[j][i]);
    }

    if (!this.expr.check(grammar, row)) {
      return false;
    }
  }

  return true;
};

pexprs.Not.prototype.check = function (grammar, vals) {
  return true;
};

pexprs.Lookahead.prototype.check = pexprs.Lex.prototype.check = function (grammar, vals) {
  return this.expr.check(grammar, vals);
};

pexprs.Apply.prototype.check = function (grammar, vals) {
  if (!(vals[0] instanceof nodes.Node && vals[0].grammar === grammar && vals[0].ctorName === this.ruleName)) {
    return false;
  } // TODO: think about *not* doing the following checks, i.e., trusting that the rule
  // was correctly constructed.


  var ruleNode = vals[0];
  var body = grammar.rules[this.ruleName].body;
  return body.check(grammar, ruleNode.children) && ruleNode.numChildren() === body.getArity();
};

pexprs.UnicodeChar.prototype.check = function (grammar, vals) {
  return vals[0] instanceof nodes.Node && vals[0].isTerminal() && typeof vals[0].primitiveValue === 'string';
};